import { useState, useEffect } from 'react';
import { getTumblerConfig } from '../../../utils/appConfig';

const stageMapping = {
  'beta': 'staging',
  'gamma': 'integ',
  'prod': 'prod'
};

export function useDomainIdentuple(domainIdentifier: string) {
  const [domainIdentuple, setDomainIdentuple] = useState<string>('');
  
  useEffect(() => {
    const config = getTumblerConfig();
    const fullRegionName = config.current.publicRegion || 'us-east-1';
    const stageName = stageMapping[config.stage] || 'staging';
    
    const [accountId, domainName] = domainIdentifier.split(':');
    const path = `swift-${fullRegionName}-${stageName}/${accountId}/${domainName}/1`;
    
    setDomainIdentuple(path);
  }, [domainIdentifier]);
  
  return domainIdentuple;
}